import { Box, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";
import { NEUTRAL } from "../../../../theme/tokens";
import { METRIC_LABEL_SX, METRIC_VALUE_SX } from "./gapsMetricsStyles";

type Props = { label: string; children: ReactNode; dataTestId: string };

/**
 * One key/value cell in the metrics drawer. The figure keeps its whole width and never wraps; on a narrow phone the
 * label gives way and wraps under itself ("HPPD VS / TARGET"), since a label read in two lines still reads, and a split
 * figure does not.
 */
export const GapsMetricCell: FC<Props> = ({ label, children, dataTestId }) => (
	<Box
		data-testid={dataTestId}
		sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 1, pb: 0.625, borderBottom: `1px solid ${NEUTRAL[200]}` }}
	>
		<Typography component="span" sx={{ ...METRIC_LABEL_SX, minWidth: 0, overflowWrap: "anywhere" }}>
			{label}
		</Typography>
		<Box component="span" sx={{ ...METRIC_VALUE_SX, flex: "none" }}>
			{children}
		</Box>
	</Box>
);
